module.exports = __webpack_public_path__ + "static/img/pc-cover@1x.4db2da67.png";